import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuthContext';

export default function Navbar() {
  const { currentUser, logout } = useAuth();

  return (
    <nav className="navbar">
      <Link to="/" className="navbar-brand">
        <div className="brand-icon">🫀</div>
        Moj Pritisak
      </Link>

      <div className="navbar-right">
        {currentUser && (
          <>
            <span className="navbar-user">
              👤 {currentUser.displayName || currentUser.email}
            </span>
            <button className="btn btn-ghost btn-sm" onClick={logout}>
              Odjava
            </button>
          </>
        )}
      </div>
    </nav>
  );
}
